import moment from 'moment';

const LogHistoryListColumns = ({ showEntityCollumn = false }: { showEntityCollumn?: boolean }) => {
  const defaultCollumns = [
    {
      name: 'Effective Date',
      grow: 2,
      cell: (row: any) => (
        <div
          style={{
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            whiteSpace: 'normal',
          }}
        >
          {moment(row.createdAt).format('MM/DD/YYYY hh:mm A')}
        </div>
      ),
    },
    {
      name: 'Action Type',
      grow: 1,
      cell: (row: any) => (
        <div
          style={{
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            whiteSpace: 'normal',
          }}
        >
          {row?.actionType}
        </div>
      ),
    },
    {
      name: 'Changed Information',
      grow: 4,
      cell: (row: any) => (
        <div
          style={{
            maxWidth: '100%',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            whiteSpace: 'normal',
          }}
        >
          <ul style={{ padding: 0, margin: 0, listStyle: 'none' }}>
            <>
              {Object.keys(row.changesData).map((key, i) => {
                const { old, new: newData } = row.changesData[key];
                return (
                  <li
                    key={i}
                    style={{
                      marginBottom: '8px',
                      wordBreak: 'break-word',
                      overflowWrap: 'break-word',
                      whiteSpace: 'normal',
                    }}
                  >
                    <span className="font-weight-bold">{key}:&nbsp;</span>
                    {old && (
                      <span
                        style={{
                          wordBreak: 'break-word',
                          overflowWrap: 'break-word',
                        }}
                      >
                        {old} to{' '}
                      </span>
                    )}
                    <span
                      style={{
                        wordBreak: 'break-word',
                        overflowWrap: 'break-word',
                      }}
                    >
                      {newData}
                    </span>
                  </li>
                );
              })}
            </>
          </ul>
        </div>
      ),
    },
    {
      name: 'Changed by',
      grow: 2,
      cell: (row: any) =>
        row?.updatedBy ? (
          <div
            className="d-flex align-items-center"
            style={{
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
              whiteSpace: 'normal',
            }}
          >
            <div style={{ width: '35px', height: '35px', borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
              <img
                src={row?.updatedByUser?.picture}
                alt="User Profile"
                className="img-fluid"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </div>
            <span
              className="ml-2"
              style={{
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
              }}
            >
              {`${row?.updatedByUser?.firstName || '-'} ${row?.updatedByUser?.lastName || '-'}`}
            </span>
          </div>
        ) : (
          <div
            style={{
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
              whiteSpace: 'normal',
            }}
          >
            -
          </div>
        ),
    },
  ];

  return showEntityCollumn
    ? [
        ...[
          {
            name: 'Entity',
            grow: 2,
            cell: (row: any) => (
              <div
                style={{
                  wordBreak: 'break-word',
                  overflowWrap: 'break-word',
                  whiteSpace: 'normal',
                }}
              >
                {row?.entity}
              </div>
            ),
          },
        ],
        ...defaultCollumns,
      ]
    : defaultCollumns;
};
export default LogHistoryListColumns;
